import React from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
// import styles from './index.scss'

interface Props {
    flex?: number;
}

const Spacer: React.FC<Props> = (props) => {

    const {
        flex = 1
    } = props;

    const SpacerStyle: ViewStyle = {
        flex: flex
    };

    return (
        <View {...props} style={[styles.spacer, SpacerStyle]}>
            {props.children}
        </View>
    );

};

const styles = StyleSheet.create({
    spacer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});

export {
    Spacer
}